import { render } from "./import.vue?vue&type=template&id=6c292739"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"
script.render = render

export default script